module.exports = __webpack_public_path__ + "static/media/x-circle-red.9bd4e0ad.svg";